import { Components, Theme } from '@mui/material/styles';

export const chipConfigs: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      height: 22,
      padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,

      '.MuiChip-label': {
        textTransform: 'uppercase',
        padding: 0,
        fontSize: theme.typography.caption2Bold.fontSize,
        fontWeight: theme.typography.caption2Bold.fontWeight,
      },
    }),
  },
};
